import { v4 as uuid } from "uuid";

import { MarkerBall, MarkerType, StencilType } from "../types";

export interface CreateNewBallProps extends Partial<MarkerBall> {
  pos: MarkerBall["pos"];
  associatedPlayer: MarkerBall["associatedPlayer"];
}

export const createNewBall = (ballProps: CreateNewBallProps): MarkerBall => {
  return {
    id: uuid(),
    stencilType: StencilType.MARKER,
    markerType: MarkerType.BALL,
    movements: [],
    ...ballProps,
  };
};
